import { useEffect, useState } from 'react'

const smallScreen = window.matchMedia('(max-width: 700px)')
const middleScreen = window.matchMedia('(max-width: 1250px)')
const bigScreen = window.matchMedia('(min-width: 1251px)')

export function useMediaSize(num: number): string[] {
  const screens = [smallScreen, middleScreen, bigScreen]
  const [widthNum, setWidthNum] = useState<Array<string>>([])

  const generateWidthNum = (
    interval: number,
    split: number,
    num: number,
  ): void => {
    const widthNum = []
    for (let index = 0, init = 1; index < num * 2; index += 1) {
      if (init > 25) init = 1
      widthNum.push(String(init))
      init += index % 2 !== 0 && init !== 1 ? split : interval
    }
    setWidthNum(widthNum)
  }
  const handlerSmall = (smallScreen: MediaQueryList | MediaQueryListEvent) => {
    if (smallScreen.matches) {
      generateWidthNum(24, 0, num)
    }
  }
  const handlerMiddle = (
    middleScreen: MediaQueryList | MediaQueryListEvent,
  ) => {
    if (middleScreen.matches) {
      generateWidthNum(11, 2, num)
    }
  }
  const handlerBig = (bigScreen: MediaQueryList | MediaQueryListEvent) => {
    if (bigScreen.matches) {
      generateWidthNum(4, 1, num)
    }
  }
  const handlers = [handlerSmall, handlerMiddle, handlerBig]

  useEffect(() => {
    handlers.forEach((handler, index) => {
      // Set size at the first client-side load
      handler(screens[index])

      screens[index].addEventListener('change', handler)
    })

    // Remove event listener on cleanup
    return () => {
      handlers.forEach((handler, index) => {
        screens[index].addEventListener('change', handler)
      })
    }
  }, [])

  return widthNum
}
